import Swal from 'sweetalert2';

$(document).ready(function () {
    /** ADDRESS-ACCOUNT **/
    if (strPage == 'address-account') {
        // Form validate
        FormValidateAddressAccount($('form#frmAddressAccount'));
    }

    /** ADDRESS-BOOK **/
    else if (strPage == 'address-book') {
        // When clicking on button 'Add new address' => slide open the form below
        $('#addaddress').click(function () {
            // $(this).parent().hide();
            $('form#frmAddAddress').removeClass('d-none');

            $('div.alert.address-added').hide();
            return false;
        });

        // Remove address
        $('button[id*="deleteaddress"]').click(function () {
            var objThis = $(this);
            var arrId = $(this).attr('id').split('-');
            var intId = arrId[1];

            $.post(strAjaxPath + 'customerzone/delete-address.php', 'addresssalesorderno=' + intId, function (data) {
                // Hide address
                objThis.closest('form').hide();
                // Hide checkbox next to it
                // objThis.parent().parent().parent().next().next().hide();
                // Show notification when address is removed
                //objThis.parent().parent().parent().children("div.alert").slideDown('fast');
            });
            return false;
        });

        // Update address
        $('button[id*="updateaddress"]').click(function () {
            // Make address invisible
            var objLink = $(this);
            var objParent = objLink.parents('form');
            objParent.find('address').addClass('d-none');
            objParent.find('.edit-address-form').removeClass('d-none');
            objLink.parent().parent().toggleClass('d-none');
            return false;
        });

        $('.cancel').click(function () {
            var objLink = $(this);
            var objParent = objLink.parents('form');
            objParent.find('.d-none').removeClass('d-none');
            objParent.find('.edit-address-form').addClass('d-none');
            return false;
        });

        // Indicate address as standard delivery address
        $('.defaultaddress').on('click', function () {
            var objThis = $(this);

            // Check out other radiobuttons
            $('.defaultaddress').each(function () {
                if (objThis.val() != $(this).val()) {
                    $(this).prop('checked', false);
                }
            });

            // Update default delivery address
            $.post(strAjaxPath + 'customerzone/set-defaultaddress.php', 'addresssalesorderno=' + objThis.val(), function (data) {

            }, 'json');
        });

        // Form validate 'Add new adress' (in address book)
        FormValidateAddAddress($('form#frmAddAddress'));

        // Form validate 'Edit adress' (in address book) (per address)
        $.each(arrSalesorderAddresses, function (i, val) {
            FormValidateUpdateAddress($('form#frmUpdateAddress' + val));
        });
    }

    /** ADDRESS-DATA **/
    else if (strPage == 'address-data') {
        // Form validate
        FormValidateAddressData($('form#frmAddressData'));
    }

    /** ORDERS **/
    else if (strPage == 'orders') {
        // Accordion
        $('.accordion-order a').click(function () {
            var objA = $(this);
            var objDiv = $(this).next();
            $(objA).find('i.fa').toggleClass('fa-angle-right fa-angle-down');
            $(objDiv).slideToggle('fast', function () {
            });

            return false;
        });

        $('[id^=invoice_]').click(function (e) {
            e.stopPropagation();
            var invoice_id = $(this).attr('id').split('_')[1];
            window.open("/exopera/pdf/frontend/salesinvoice/"+ invoice_id +"/show", '_blank');
        });
    }

    /** ADDRESS GIFTCARDS **/
    else if (strPage == 'address-giftcards') {

        $('#frmActivate input[type="button"]').click(function (e) {
            $('form#frmActivate').find('.alert-danger').remove();

            if ($('#txtGiftcardCode').val()) {
                // Remove previous errors
                $('#txtGiftcardCode').removeClass('is-invalid');

                // Validate
                var strParams = 'intAddressNo=' + intAddressNo + '&strGiftCardCode=' + $('input#txtGiftcardCode').val();
                $.post(strAjaxPath + 'customerzone/address-giftcard.php', strParams, function (data) {
                    if (data.value == 0) {
                        // Show error
                        $('form#frmActivate').append('<div class=\'alert alert-danger mt-2 ml-3\'>' + data.message + '</div>');
                    } else if (data.value == 1) {
                        // Correct code => reload page
                        document.location.reload();
                    }
                }, 'json');
            } else {
                $('form#frmActivate').append('<div class=\'alert alert-danger mb-0 ml-3\'>' + strLabelRequired + '</div>');
                $('#txtGiftcardCode').addClass('is-invalid');
            }

            return false;
        });
    }

    /** POUR QUI BIOGRAPHY **/
    else if (strPage == 'pour-qui-biography') {
        // Form validate
        FormValidatePourQuiBiography($('form#frmPourQuiBiography'));

        // Click on 'Upload photo' button
        $('#btnUploadPhoto').click(function () {
            $('#filPhoto').click();

            // After uploading
            $('#filPhoto').on('change', function () {
                // Submit form
                $(this).closest('form').submit();
            });
        });
    }

    /** POUR QUI OFFER **/
    else if (strPage == 'pour-qui-offer') {
        // Set max width for popup (conditions pages)
        $('[data-fancybox]').fancybox({
            iframe: {
                css: {
                    width: '800px',
                    height: '80%',
                },
            },
        });

        // Own product: check if there were errors after submitting the form 'Add own product'
        if (blnErrorOwnProduct) {
            // Show the popup with the form if there are errors
            $('#link-add-own-product').click();
        }


        // Own product: show the 'Own product' popup (to add or edit one)
        $('#ownProduct').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget); // Button that triggered the modal
            var modal = $(this);

            // Get form to add/edit own product
            $.post(strAjaxPath + 'customerzone/pour-qui/get-form-own-product.php', 'articleno=' + button.data('key'), function (data) {
                // Add form in popup
                modal.find('.modal-body').html(data);

                // Show the right title
                modal.find('.modal-header').find('span').each(function () {
                    if (!$(this).hasClass('d-none')) {
                        $(this).addClass('d-none');
                    }
                });
                modal.find('.modal-header').find('[data-name=' + button.data('type') + ']').removeClass('d-none');

                // After uploading images
                document.getElementById('filImages').onchange = function () {
                    var files = [];
                    var exceeded = '';
                    var filecontainer = document.getElementById('previewImages');

                    for (var i = 0; i < this.files.length; i++) {
                        //Filter out files that are to large (max 2mb)
                        if (this.files[i].size > 2000000) {
                            var sizeinmb = this.files[i].size / 1000000;
                            exceeded += this.files[i].name + ' (' + sizeinmb.toFixed(2) + 'Mb)<br/>';
                        } else {
                            files[i] = this.files[i];
                        }
                    }

                    //Show error if file limit has exceeded for some files
                    if (exceeded !== '') {
                        Swal.fire({
                            title: 'error',
                            html: strLabelUploadFilesErrorMaxFilesize + ': <br/>' + exceeded,
                            icon: 'error',
                        });
                    }

                    //Set max limit for uploading images
                    if (files.length > 5) {
                        files.length = 5;
                        Swal.fire({
                            title: 'error',
                            html: strLabelUploadFilesErrorMaxAmount,
                            icon: 'error',
                        });
                    }

                    if (files.length > 0) {
                        // Show thumbs and reset button
                        readURL(files, filecontainer);
                    }
                };

                // Clicking the reset button to start image upload again
                document.getElementById('resetImages').onclick = function () {
                    //Empty current uploaded images
                    document.getElementById('filImages').value = '';
                    document.getElementById('previewImages').innerHTML = '';

                    //hide reset button and show text
                    toggleImageInfo();

                    return false;
                };

                // Own product: form validate
                FormValidateOwnProduct($('form#frmOwnProduct'));

                // Delete image
                $('button[data-type="delete-image"]').click(function () {
                    // Remove this image from html
                    $(this).closest('div').remove();
                    return false;
                });
            }, 'html');
        });

        // Own product: delete an own product => confirm in popup
        $('#deleteOwnProduct').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget); // Button that triggered the modal
            var modal = $(this);
            modal.find('h2').text(button.data('name'));
            modal.find('#hdnRemoveArticle').val(button.data('key'));
            // modal.find('#btnRemove').click()
            //$(this).find('.btn-ok').attr('href', $(event.relatedTarget).data('href'));
        });

        // Dedicasses/commissions: click on radio button for type
        $('input[name^="rdbType"]').click(function () {
            var intType = $(this).val();
            // Add this type for logged in address
            $.post(strAjaxPath + 'customerzone/pour-qui/save-category.php', 'categoryno=' + intType, function (data) {
                // Show formats from this type
                $('div[data-key="type-wrapper-' + intType + '"]').removeClass('d-none');
            }, 'json');
        });

        // Dedicasses/commissions: click on delete button for type
        $('a[data-type="delete-type"]').click(function () {
            var intType = $(this).data('key');
            // Remove this type from logged in address
            $.post(strAjaxPath + 'customerzone/pour-qui/save-category.php', 'categoryno=' + intType + '&action=delete', function (data) {
                // Hide formats from this type
                $('div[data-key="type-wrapper-' + intType + '"]').addClass('d-none');

                // Deselect radio button for this type
                $('#rdbType_' + intType).prop('checked', false);
            }, 'json');
            return false;
        });

        // Dedicasses/commissions: click on checkbox for format
        $('input[name^="chkFormat"]').click(function () {
            var intFormat = $(this).val();
            var strAction = 'add';
            // Check if checkbox was checked or unchecked
            if (!$(this).prop('checked')) {
                strAction = 'delete';
            }
            // Add this type for logged in address
            $.post(strAjaxPath + 'customerzone/pour-qui/save-category.php', 'categoryno=' + intFormat + '&action=' + strAction, function (data) {

            }, 'json');
        });

        // Dedicasses/commissions: click on checkbox for product
        $('input[name^="chkProduct"]').click(function () {
            var intProduct = $(this).val();
            var strAction = 'add';
            // Check if checkbox was checked or unchecked
            if (!$(this).prop('checked')) {
                strAction = 'delete';
            }

            // Check if product added
            if (strAction == 'add') {
                // Check if format from this product is checked
                var objInputFormat = $('input#chkFormat_' + $(this).closest('div').data('category'));
                if (objInputFormat.prop('checked') == false) {
                    // Format from this product is not checked => check the format
                    objInputFormat.click();
                }
            }

            // Add this type for logged in address
            $.post(strAjaxPath + 'customerzone/pour-qui/save-product.php', 'articleno=' + intProduct + '&action=' + strAction, function (data) {

            }, 'json');
        });

        // Dedicasses/commissions: click on pencil to change the name
        $('a[data-type="change-name"]').click(function () {
            if ($(this).data('catprod') == 'prod') {
                var objWrapper = $(this).closest('div[data-type="product-wrapper"]');
            } else {
                var objWrapper = $(this).closest('div[data-type="category-wrapper"]');
            }
            // Show input field with name and hide label with name
            objWrapper.find('label[data-type="label"]').addClass('d-none');
            objWrapper.find('label[data-type="input"]').removeClass('d-none');

            // Hide button itself
            $(this).addClass('d-none');

            return false;
        });

        // Dedicasses/commissions: click on save icon next to input field
        $('a[data-type="save-name"]').click(function () {
            if ($(this).data('catprod') == 'prod') {
                var objWrapper = $(this).closest('div[data-type="product-wrapper"]');
                var strField = 'articleno';
            } else {
                var objWrapper = $(this).closest('div[data-type="category-wrapper"]');
                var strField = 'categoryno';
            }

            var strNewName = $(this).closest('label').find('input').val();
            // Check if value in input field is not empty
            if (strNewName == '') {
                // Remove previous errors
                $(this).parent().find('span.alert').remove();
                // Show error that the input field can not be empty
                $(this).after('<span class="alert alert-danger py-1 px-2">' + strLabelGiveAName + '</span>');
            } else {
                // Save new name
                $.post(strAjaxPath + 'customerzone/pour-qui/save-name.php', strField + '=' + objWrapper.find('input[type="checkbox"]').val() + '&name=' + strNewName, function (data) {
                    // Update name in label and show label and hide input field
                    objWrapper.find('label[data-type="label"]').find('span').text(strNewName);
                    objWrapper.find('label[data-type="label"]').removeClass('d-none');
                    objWrapper.find('label[data-type="input"]').addClass('d-none');
                    objWrapper.find('a[data-type="change-name"]').removeClass('d-none');
                }, 'json');
            }
            return false;
        });
    }

    /** CUSTOM: CUSTOMERZONE **/
    else if (strPage == 'customerzone') {

    } else if (strPage == 'mailalerts') {

        $('a.delete-alert').click(function () {
            var objItem = $(this);
            var intKey = $(this).data('key');
            // Remove this type from logged in address
            $.post(strAjaxPath + 'customerzone/delete-alert.php', 'stockcheckno=' + intKey, function (data) {
                // Hide formats from this type
                if (data.value == 1) {
                    objItem.parent().parent().remove();
                }
            }, 'json');
            return false;
        });
    } else if (strPage === 'subscriptions') {
        var Timer;
        $("input#txtSeries").keyup(function (e) {
            clearTimeout(Timer);

            if ($(this).val().length >= 2 && e.which != 13) {
                Timer = setTimeout(
                    (function (opts) {
                        return function () {
                            GetSerieNo(opts);
                        };
                    })($(this).val()), 700);
            } else {
                $("div.suggestion-series").addClass("d-none");
            }
        });

        $('#BdLang').on('change', function () {
            GetSerieNo();
        });

        // Form validate
        FormValidateAddSubscription($('form#formAddSubscription'));

        $('a.edit-subscription').click(function () {
            $('#edit-subscription').remove();
            var objItem = $(this).closest("div.subscription");
            var intKey = $(this).data('key');

            $.ajax({
                type: 'GET',
                url: strAjaxPath + 'customerzone/edit-subscription.php',
                data: {
                    subscriptionid: intKey,
                },
                success: function (data) {
                    if (data != "") {
                        objItem.after(data);
                        objItem.addClass("d-none");
                        objItem.removeClass("d-flex");

                        $('#edit-subscription .cancel').click(function () {
                            objItem.removeClass('d-none');
                            objItem.addClass('d-flex');
                            $('#edit-subscription').remove();
                            return false;
                        });

                        $('a.edit-subscription').click(function () {
                            objItem.removeClass('d-none');
                            objItem.addClass('d-flex');
                            $('#edit-subscription').remove();
                            return false;
                        });
                    }
                },
                dataType: 'text',
            });

            return false;
        });

        $('a.delete-subscription').click(function () {
            var objItem = $(this);
            var intKey = $(this).data('key');
            var strName = $(this).data('name');
            var strLabel = strLabelConfirmDelete.replace('[NAME]', '\'' + strName + '\'');
            var blnConfirm = confirm(strLabel);

            if (blnConfirm) {
                $.post(strAjaxPath + 'customerzone/delete-subscription.php', 'subscriptionid=' + intKey, function (data) {
                    if (data.value == 1) {
                        objItem.parent().parent().remove();
                    }
                }, 'json');
            }
            return false;
        });

        // Add new subscription address
        FormValidateAddAddress($('form#frmAddAddress'));

        $('#addaddress').click(function () {
            // $(this).parent().hide();
            $('form#frmAddAddress').removeClass('d-none');

            $('div.alert.address-added').hide();
            return false;
        });

        $('button[id*="change-subscription-settings"]').click(function () {
            $('#subscription-settings').addClass('d-none');
            $('#subscription-settings-form').removeClass('d-none');
            $('#save-subscription-settings').removeClass('d-none');
            $(this).addClass('d-none');
            return false;
        });

        $('#save-subscription-settings .cancel').click(function () {
            $('#subscription-settings').removeClass('d-none');
            $('#subscription-settings-form').addClass('d-none');
            $('#change-subscription-settings').removeClass('d-none');
            $('#save-subscription-settings').addClass('d-none');
            return false;
        });

        $('#save-subscription-settings .submit').click(function () {
            var optSubscriptionAddress = $('input[name="optSubscriptionAddress"]:checked').val();
            var optPickUpPoint =$('input[name="optPickUpPoint"]:checked').val();

            $('#intSubscriptionAddressNo').val(optSubscriptionAddress);
            $('#intSubscriptionCompanyNo').val(optPickUpPoint);
            $('#formSubscriptionSettings').submit();
        });

        // Indicate address as subscription delivery address
        // $('.subscriptionaddress').on('click', function () {
        //     var objThis = $(this);
        //     // Update default delivery address
        //     $.post(strAjaxPath + 'customerzone/set-subscriptionaddress.php', 'addresssalesorderno=' + objThis.val(), function (data) {
        //
        //     }, 'json');
        // });

        $('input[name="subscription_type"]').on('change', function () {
            var objThisVal = $(this).val();
            $('#monthday').addClass('d-none');
            $('#weekday').addClass('d-none');

            if (objThisVal == 1) {
                $('#weekday').removeClass('d-none');
            } else if (objThisVal == 2) {
                $('#monthday').removeClass('d-none');
            }
        });

        $("input[name='optDeliveryOption']").change(function () {
            if ($("#optDeliveryOption-2").is(":checked")) {
                $('#delivery-addresses').addClass("d-none");
                $('#pick-up-points').removeClass("d-none");
                $('#deliveryinfo').removeClass("d-none");
            } else if ($("#optDeliveryOption-1").is(":checked")) {
                $('#pick-up-points').addClass("d-none");
                $('#deliveryinfo').addClass("d-none");
                $('#delivery-addresses').addClass("d-none");
            } else {
                $('#pick-up-points').addClass("d-none");
                $('#deliveryinfo').addClass("d-none");
                $('#delivery-addresses').removeClass("d-none");
            }
        });

        // Click on 'Edit' button for payments
         $('button#change-subscription-payment').click(function () {
            // Show form to edit payment
            $('#subscription-payment').addClass('d-none');
            $('#subscription-payment-form').removeClass('d-none');
            $('#save-subscription-payment').removeClass('d-none');
            $(this).addClass('d-none');
            return false;
        });

        // Click on 'Cancel' button for payments
        $('#save-subscription-payment .cancel').click(function () {
            // Hide form to edit payment
            $('#subscription-payment').removeClass('d-none');
            $('#subscription-payment-form').addClass('d-none');
            $('#change-subscription-payment').removeClass('d-none');
            $('#save-subscription-payment').addClass('d-none');
            return false;
        });

         // Click on 'Save' button for payments
        $('#save-subscription-payment .submit').click(function () {
            // Submit form to edit payment
            $('#formSubscriptionPayment').submit();
        });

        // Choose a payment method
        $("input[name='optPaymentMethod']").change(function(){
            if ($(this).val() == intPaymentMethodWallet){
                // Show value of wallet block
                $('#wallet-value').removeClass('d-none');
            } else {
                // Hide value of wallet block
                $('#wallet-value').addClass('d-none');
            }
        });

        // Click on 'Add' button to add a value to the wallet
        AddWalletToCart(strHrefPopupProductWalletAdded);
    }

    /** NEW PRODUCTS ORDER **/
    else if (strPage == 'new-products-order') {
        $('button.add-line').click(function () {
            var strExtraLine = $(this).parent().prev().clone();
            strExtraLine.find('a.remove-line').addClass('d-flex').removeClass('d-none');
            strExtraLine.find('input:not([readonly])').val('');
            strExtraLine.insertAfter($(this).parent().prev());

            $(this).parent().prev().find("input:not([readonly]):first").focus();

            $('a.remove-line').click(function () {
                $(this).closest('div.form-group').remove();
                return false;
            });

            return false;
        });

        // Form validate
        FormValidateNewProductOrder($('form#frmNewProductOrder'));
    }

    // Show left menu mobile
    $('.toggle-cz-menu').click(function () {
        $('body').toggleClass('cz-menu-open');
    });

    // Show left menu mobile
    $('a.showfilters').click(function () {
        $('body').removeClass('push-menu');
        $('body').toggleClass('push-filter');
        $(this).toggleClass('active');
    });

    $('a.hidefilters').click(function () {
        $('body').removeClass('push-filter');
        $('a.showfilters').removeClass('active');
    });


});


// Pour qui: own products - file upload
window.readURL = function (files, filecontainer) {
    //show reset button
    toggleImageInfo();

    // Show thumbs
    for (var i = 0; i < files.length; i++) {
        //Load src of image
        var reader = new FileReader();
        reader.onload = function (e) {
            //create new img to display uploaded files
            var image = new Image();
            image.src = e.target.result;
            image.height = 60;
            image.classList.add('m-2');

            //Add image to container
            filecontainer.appendChild(image);
        };
        reader.readAsDataURL(files[i]);
    }
};


// Pour qui: own products - file upload - show or hide image image or show reset button
function toggleImageInfo() {
    document.getElementById('infoImages').classList.toggle('d-none');
    document.querySelector('label[for="filImages"]').classList.toggle('d-none');
    document.getElementById('resetImages').classList.toggle('d-none');
}

function GetSerieNo() {
    var strBdLang = $("#BdLang").val();
    var strTxtSeries = $("#txtSeries").val();
    $('form#formAddSubscription').find('.invalid-feedback').remove();
    $("select#cover").html("");
    $("#serieno").val("");

    // Toon loading spinner
    $(".series-loading").removeClass("d-none");

    $.ajax({
        type: 'GET',
        url: strAjaxPath + 'customerzone/series-suggest.php',
        data: {
            strTxtSeries: strTxtSeries,
            strBdLang: strBdLang,
        },
        success: function (data) {
            if (data != "") {
                $("div.suggestion-series").html(data);
                $("div.suggestion-series").removeClass("d-none");
            } else {
                $("div.suggestion-series").addClass("d-none");
            }

            if ($('div.suggestion-series a').length > 0) {
                $('div.suggestion-series a').on('click', function (e) {
                    $("#serieno").val($(this).data("serieno"));
                    $("#txtSeries").val($(this).data("seriename"));
                    $("div.suggestion-series").html('');
                    $("div.suggestion-series").addClass("d-none");

                    // Get covers for serie
                    GetCovers();
                });
            }

            $(document).mouseup(function (e) {
                var container = $("div.suggestion-series");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    container.addClass("d-none");
                }
            });
        },
        error: function () {
            console.error("Fout bij ophalen series.");
        },
        complete: function () {
            // Verberg loading spinner, ongeacht succes of fout
            $(".series-loading").addClass("d-none");
        },
        dataType: 'text',
    });
}

function GetCovers() {
    $("#addSubscriptions").prop("disabled", true);
    var strBdLang = $("#BdLang").val();
    var intSerieNo = $("#serieno").val();

    $.ajax({
        type: 'GET',
        url: strAjaxPath + 'customerzone/cover-suggest.php',
        data: {
            intSerieNo: intSerieNo,
            strBdLang: strBdLang,
        },
        success: function (data) {
            if (data != "") {
                $("select#cover").html(data);
                $("#addSubscriptions").prop("disabled", false);
            }
        },
        dataType: 'text',
    });
}
